export const rubberLayout = () => {
  document.querySelector('body').classList.add('rubberLayout');
  return function() {
    document.querySelector('body').classList.remove('rubberLayout');
  };
}